import { render } from "./AvatarPose.vue?vue&type=template&id=5a6dcf6d"
import script from "./AvatarPose.vue?vue&type=script&lang=js"
export * from "./AvatarPose.vue?vue&type=script&lang=js"

import exportComponent from "/app/widget-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__